import { DtoBase } from "../DtoBase";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { EventDto } from "./EventDto";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { ValueEncoder } from "../../DiscoveryEngine.TS/Utils/ValueEncoder";

export class EventListDto extends DtoBase {

	public ServerGuid: string;
	public TenantGuid: string;
	public UserGuid: string;
	public ScopeGuid: string;
	public AgentGuid: string;
	public ClientAgentGuid: string;
	public Entries: List<EventDto>;
	public TotalCount: number;

	constructor() {
		super();

		this.Clear();
	}

	public Clear(): void {
		this.ServerGuid = "";
		this.TenantGuid = "";
		this.UserGuid = "";
		this.ScopeGuid = "";
		this.AgentGuid = "";
		this.ClientAgentGuid = "";
		this.Entries = new List<EventDto>();
		this.TotalCount = -1;
	}

	public get HasServerGuid(): boolean {
		return !!this.ServerGuid;
	}

	public get HasTenantGuid(): boolean {
		return !!this.TenantGuid;
	}

	public get HasUserGuid(): boolean {
		return !!this.UserGuid;
	}

	public get HasScopeGuid(): boolean {
		return !!this.ScopeGuid;
	}

	public get HasAgentGuid(): boolean {
		return !!this.AgentGuid;
	}

	public get HasClientAgentGuid(): boolean {
		return !!this.ClientAgentGuid;
	}

	public get HasEntries(): boolean {
		return (this.Entries && this.Entries.Count > 0);
	}

	public get HasTotalCount(): boolean {
		return (this.TotalCount >= 0);
	}

	public AddEntry(entry: EventDto): void {
		this.Entries.Add(entry);
	}

	public Write(obj: any, context: any): void {
		obj.event_list = {};
		obj = obj.event_list;

		super.Write(obj, context);

		if (this.HasServerGuid)
			obj.server_guid = this.ServerGuid;

		if (this.HasTenantGuid)
			obj.tenant_guid = this.TenantGuid;

		if (this.HasUserGuid)
			obj.user_guid = this.UserGuid;

		if (this.HasScopeGuid)
			obj.scope_guid = this.ScopeGuid;

		if (this.HasAgentGuid)
			obj.agent_guid = this.AgentGuid;

		if (this.HasClientAgentGuid)
			obj.client_agent_guid = this.ClientAgentGuid;

		if (this.HasEntries) {
			obj.entries = [];
			ObjSerUtils.WriteObjSerCollection(obj.entries, this.Entries, context);
		}

		if (this.HasTotalCount)
			obj.total_count = ValueEncoder.EncodeInteger(this.TotalCount);
	}

	public Read(obj: any, context: any): void {

		if (!obj.event_list)
			throw new Error();
		obj = obj.event_list;

		super.Read(obj, context);

		if (obj.server_guid !== undefined)
			this.ServerGuid = obj.server_guid;

		if (obj.tenant_guid !== undefined)
			this.TenantGuid = obj.tenant_guid;

		if (obj.user_guid !== undefined)
			this.UserGuid = obj.user_guid;

		if (obj.scope_guid !== undefined)
			this.ScopeGuid = obj.scope_guid;

		if (obj.agent_guid !== undefined)
			this.AgentGuid = obj.agent_guid;

		if (obj.client_agent_guid !== undefined)
			this.ClientAgentGuid = obj.client_agent_guid;

		if (obj.entries !== undefined) {
			ObjSerUtils.ReadObjSerCollection(obj.entries, this.Entries,
				(value: any) => new EventDto(), context);
		}

		if (obj.total_count !== undefined)
			this.TotalCount = ValueEncoder.DecodeInteger(obj.total_count);		
	}

}
